/* eslint-disable max-classes-per-file */
import Singleton from '../Singleton';
import ErrorService from './ErrorService';

interface IStorage {
  getItem(key: string): any | null;
  setItem(key: string, value: any): void;
  removeItem(key: string): void;
  clear(): void;
}

class StorageService extends Singleton<StorageService> implements IStorage {
  protected storage: Storage;

  getItem(key: string): any {
    return JSON.parse(this.storage.getItem(key));
  }

  setItem(key: string, value: any): void {
    try {
      this.storage.setItem(key, JSON.stringify(value ?? {}));
    } catch (e) {
      if (
        e instanceof DOMException &&
        (e.name === 'QuotaExceededError' ||
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED' ||
          e.name === 'QUOTA_EXCEEDED_ERR')
      ) {
        ErrorService.trackError(e);

        this.clear();
        this.storage.setItem(key, JSON.stringify(value ?? {}));
      }
    }
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }
}

class LocalStorageService extends StorageService {
  constructor() {
    super();
    this.storage = localStorage;
  }
}

class SessionStorageService extends StorageService {
  constructor() {
    super();
    this.storage = sessionStorage;
  }
}

const localStorageService = new LocalStorageService();
const sessionStorageService = new SessionStorageService();

export { localStorageService, sessionStorageService };
